import React, { useState, useEffect } from "react";
import Dropdown from "react-dropdown-select";
import { NewsCategories as GetCategories } from "../../../queries/common_use_query";
import { navigate } from "gatsby";

const NewsCategories = ({ categorySlug }) => {
    const { data, loading, error } = GetCategories();
    const [options, setOptions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("All Blogs");

    useEffect(() => {
        if (data) {
            const categories = data.newsCategories.map(category => ({
                label: category.Name,
                value: category.URL
            }));
            setOptions(categories);
        }
    }, [data]);

    useEffect(() => {
        if (categorySlug) {
            setSelectedCategory(categorySlug);
        } else {
            setSelectedCategory("All Blogs");
        }
    }, [categorySlug]);

    const handleChange = (selectedOptions) => {
        const selectedValue = selectedOptions && selectedOptions.length > 0 ? selectedOptions[0].value : null;
        setSelectedCategory(selectedValue);
        if (selectedValue === '') {
            navigate(`/about/latest-property-news`);
        } else {
            navigate(`/blog/category/${selectedValue}`);
        }
    };

    return (
        <Dropdown
            options={[
                { label: 'All Blogs', value: '' }, 
                ...options
            ]}
            values={[{ label: options.find(option => option.value === selectedCategory)?.label || "All Blogs", value: selectedCategory }]}
            onChange={(values) => handleChange(values)}
            searchable={false}
            placeholder="Choose category"
            className="news-category-dropdown"
        />
    );
};

export default NewsCategories;